import { Injectable } from '@angular/core';

import { FunctionDto } from '@osos/shared/api';
import { CustomFunctionPresenterModel } from '@osos/shared/types';
import { FactoryBase } from '../../bases/factory/factory-base';
import { FunctionsParserV1Service } from '../../parsers/index';
import { ParserFactory } from '../../services';

@Injectable()
export class FunctionsFactoryService extends FactoryBase<
  FunctionDto,
  CustomFunctionPresenterModel
> {
  constructor(
    parserFactory: ParserFactory,
    parser_v1: FunctionsParserV1Service,
  ) {
    super(parserFactory);
    // register the related parsers within the parser factory:
    parserFactory.register(parser_v1);
  }

  createDataModel(presenter: CustomFunctionPresenterModel): FunctionDto {
    const parser = this.getParser(FunctionDto, CustomFunctionPresenterModel);
    const result = parser.getDataModel(presenter);

    return result;
  }

  createPresenterModel(model: FunctionDto): CustomFunctionPresenterModel {
    const parser = this.getParser(FunctionDto, CustomFunctionPresenterModel);
    const result = parser.getPresenterModel(model);
    return result;
  }
}
